import { Tooltip, styled, tooltipClasses } from "@mui/material";
import { ReactElement, ReactNode } from "react";
import { DefaultProps } from "../../common/types";

interface WithTooltipProps extends DefaultProps {
    title?: string;
    titleWidth?: string | number;
    children: ReactNode;
    disabled?: boolean;
    followCursor?: boolean;
    disableInteractive?: boolean;
}

function WithTooltipComponent(props: WithTooltipProps): ReactElement {
    if (props.title) {
        return (
            <Tooltip
                title={props.title}
                followCursor={props.followCursor}
                placement={props.followCursor ? "top-start" : undefined}
                classes={{ popper: props.className }}
                disableInteractive={props.disableInteractive ?? true}
            >
                {props.disabled ? (
                    <span>{props.children as ReactElement}</span>
                ) : (
                    (props.children as ReactElement)
                )}
            </Tooltip>
        );
    }
    return props.children as ReactElement;
}

export const WithTooltip = styled(WithTooltipComponent, { name: "WithTooltip" })(
    ({ theme, titleWidth }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            margin: theme.spacing(4),
            padding: theme.spacing(2, 3),
            maxWidth: 320,
            width: titleWidth,
            fontSize: 13,
          }
    })
);